import { render } from "./TestimonialsSectionEditor.vue?vue&type=template&id=596393f1"
import script from "./TestimonialsSectionEditor.vue?vue&type=script&lang=js"
export * from "./TestimonialsSectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__